// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   CoursesPage.css — Member portal learning section
═══════════════════════════════════════════════════════════ */

.cp__sub {
  font-size: 0.88rem;
  color: var(--portal-muted, #6b6258);
  margin: 0 0 1.5rem;
  line-height: 1.6;
}

/* ── Loading / error / empty ── */
.cp__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 3rem;
  color: var(--portal-muted, #6b6258);
  font-size: 0.88rem;
}
.cp__spinner {
  width: 1.75rem;
  height: 1.75rem;
  border: 2px solid rgba(184, 92, 56, 0.2);
  border-top-color: #b85c38;
  border-radius: 50%;
  animation: cp-spin 0.7s linear infinite;
}
@keyframes cp-spin {
  to {
    transform: rotate(360deg);
  }
}
.cp__error-state {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 1.25rem;
  color: #dc2626;
  font-size: 0.85rem;
  background: rgba(220, 38, 38, 0.06);
  border-radius: 8px;
}
.cp__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3.5rem 1rem;
  text-align: center;
}
.cp__empty-icon {
  font-size: 3rem;
  color: var(--portal-muted, #6b6258);
  margin-bottom: 0.85rem;
}
.cp__empty-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0 0 0.45rem;
}
.cp__empty-sub {
  font-size: 0.85rem;
  color: var(--portal-muted, #6b6258);
  max-width: 380px;
  line-height: 1.6;
  margin: 0;
}

/* ══════════════════════════════════════════════════════════
   COURSE GRID (list view)
══════════════════════════════════════════════════════════ */
.cp__course-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.25rem;
}

.cp__course-card {
  text-align: left;
  background: #fff;
  border: 1px solid var(--portal-border, #e8e3da);
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.cp__course-card:hover {
  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

/* Thumbnail */
.cp__card-thumb {
  width: 100%;
  height: 160px;
  overflow: hidden;
  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);
  position: relative;
  flex-shrink: 0;
}
.cp__card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s;
}
.cp__course-card:hover .cp__card-thumb img {
  transform: scale(1.04);
}

/* Placeholder icon when no thumbnail */
.cp__card-thumb-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  color: rgba(255, 255, 255, 0.25);
}

/* Body */
.cp__card-body {
  padding: 1.1rem 1.25rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1;
}

.cp__card-access {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #6b6258;
  background: rgba(107, 98, 88, 0.1);
  padding: 0.18rem 0.55rem;
  border-radius: 99px;
  align-self: flex-start;
}

.cp__card-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0;
  line-height: 1.3;
}
.cp__card-desc {
  font-size: 0.82rem;
  color: var(--portal-muted, #6b6258);
  margin: 0;
  line-height: 1.55;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.cp__card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 0.75rem;
  border-top: 1px solid var(--portal-border, #e8e3da);
}
.cp__card-meta {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.74rem;
  color: var(--portal-muted, #6b6258);
}
.cp__card-cta {
  font-size: 0.78rem;
  font-weight: 700;
  color: #b85c38;
  letter-spacing: 0.04em;
}

/* ══════════════════════════════════════════════════════════
   COURSE VIEWER (inside a course)
══════════════════════════════════════════════════════════ */
.cp__course-viewer {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.cp__viewer-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.25rem;
  margin-bottom: 0;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.cp__back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--portal-muted, #6b6258);
  padding: 0;
  transition: color 0.15s;
}
.cp__back-btn:hover {
  color: #b85c38;
}

/* Course hero banner */
.cp__course-hero {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1.25rem;
  background: linear-gradient(135deg, #1e2a1e 0%, #384638 100%);
}
.cp__course-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.cp__course-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(27, 27, 27, 0.65) 0%, transparent 60%);
}
.cp__course-hero-text {
  position: absolute;
  bottom: 1.25rem;
  left: 1.5rem;
  right: 1.5rem;
}
.cp__course-hero-title {
  font-family: var(--portal-serif, Georgia, serif);
  font-size: 1.4rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 0.3rem;
}
.cp__course-hero-meta {
  display: flex;
  gap: 0.4rem;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.75);
}

/* Course header (no thumbnail) */
.cp__course-header-plain {
  background: #fff;
  border: 1px solid var(--portal-border, #e8e3da);
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.cp__course-title {
  font-family: var(--portal-serif, Georgia, serif);
  font-size: 1.35rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0;
}
.cp__course-desc {
  font-size: 0.88rem;
  color: var(--portal-muted, #6b6258);
  margin: 0;
  line-height: 1.6;
}
.cp__course-meta {
  display: flex;
  gap: 0.4rem;
  font-size: 0.78rem;
  color: var(--portal-muted, #6b6258);
}

/* ── Chapter accordion ── */
.cp__chapters {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}
.cp__chapter {
  background: #fff;
  border: 1px solid var(--portal-border, #e8e3da);
  border-radius: 12px;
  overflow: hidden;
}

.cp__chapter-head {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1rem 1.25rem;
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;
}
.cp__chapter-head:hover {
  background: rgba(184, 92, 56, 0.03);
}

.cp__chapter-num-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: rgba(30, 42, 30, 0.07);
  font-size: 0.72rem;
  font-weight: 800;
  color: #1e2a1e;
  flex-shrink: 0;
}

.cp__chapter-title-group {
  flex: 1 1;
  min-width: 0;
}
.cp__chapter-title {
  font-size: 0.92rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0;
}
.cp__chapter-subtitle {
  font-size: 0.74rem;
  color: var(--portal-muted, #6b6258);
  margin: 0.1rem 0 0;
}

.cp__chapter-toggle {
  font-size: 1rem;
  color: var(--portal-muted, #6b6258);
  flex-shrink: 0;
}

.cp__lessons {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--portal-border, #e8e3da);
}
.cp__lessons-empty {
  font-size: 0.8rem;
  color: var(--portal-muted, #6b6258);
  padding: 0.85rem 1.25rem;
  font-style: italic;
}

/* Lesson row */
.cp__lesson-row {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem 1.25rem;
  border-bottom: 1px solid var(--portal-border, #e8e3da);
  background: none;
  border-left: none;
  border-right: none;
  border-top: none;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;
  width: 100%;
}
.cp__lesson-row:last-child {
  border-bottom: none;
}
.cp__lesson-row:hover {
  background: rgba(184, 92, 56, 0.04);
}

.cp__lesson-num-badge {
  width: 1.65rem;
  height: 1.65rem;
  border-radius: 50%;
  background: rgba(107, 98, 88, 0.08);
  font-size: 0.65rem;
  font-weight: 800;
  color: var(--portal-muted, #6b6258);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cp__lesson-type-dot {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  background: #b85c38;
  flex-shrink: 0;
}
.cp__lesson-type-dot--text {
  background: #2563eb;
}
.cp__lesson-type-dot--task {
  background: #16a34a;
}
.cp__lesson-type-dot--quiz {
  background: #7c3aed;
}
.cp__lesson-type-dot--download {
  background: #d97706;
}

.cp__lesson-info {
  flex: 1 1;
  min-width: 0;
}
.cp__lesson-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #1b1b1b;
  margin: 0;
}
.cp__lesson-tags {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.15rem;
}
.cp__lesson-tag {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--portal-muted, #6b6258);
}
.cp__lesson-dur-tag {
  font-size: 0.65rem;
  color: var(--portal-muted, #6b6258);
  background: rgba(107, 98, 88, 0.07);
  padding: 0.1rem 0.45rem;
  border-radius: 99px;
}
.cp__lesson-arrow {
  font-size: 0.85rem;
  color: var(--portal-muted, #6b6258);
  flex-shrink: 0;
}

/* ══════════════════════════════════════════════════════════
   LESSON VIEWER
══════════════════════════════════════════════════════════ */
.cp__lesson-panel {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.cp__lesson-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--portal-border, #e8e3da);
  flex-wrap: wrap;
  gap: 0.5rem;
}
.cp__lesson-back {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--portal-muted, #6b6258);
  padding: 0;
  transition: color 0.15s;
}
.cp__lesson-back:hover {
  color: #b85c38;
}

.cp__lesson-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  background: rgba(184, 92, 56, 0.08);
  color: #b85c38;
  padding: 0.25rem 0.7rem;
  border-radius: 99px;
}
.cp__lesson-dur {
  font-weight: 500;
  opacity: 0.7;
}

.cp__lesson-title {
  font-family: var(--portal-serif, Georgia, serif);
  font-size: 1.35rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0;
}

/* Video — priority element, full-width with proper ratio */
.cp__video-wrap {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.cp__video-wrap iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
}
.cp__video-native {
  width: 100%;
  border-radius: 12px;
}

/* Text / task content */
.cp__text-content {
  font-size: 0.9rem;
  color: #1b1b1b;
  line-height: 1.8;
}
.cp__text-content p {
  margin: 0 0 0.85rem;
}
.cp__no-content {
  font-size: 0.85rem;
  color: var(--portal-muted, #6b6258);
  font-style: italic;
}

/* Transcript */
.cp__lesson-transcript {
  background: var(--portal-surface, #faf7f2);
  border-radius: 10px;
  padding: 1.1rem 1.25rem;
  border-left: 3px solid rgba(184, 92, 56, 0.3);
}
.cp__transcript-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--portal-muted, #6b6258);
  margin: 0 0 0.6rem;
}
.cp__transcript-text {
  font-size: 0.85rem;
  color: #1b1b1b;
  line-height: 1.75;
  margin: 0;
  white-space: pre-wrap;
}

/* Download block */
.cp__download-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.85rem;
  padding: 2.5rem 2rem;
  background: var(--portal-surface, #faf7f2);
  border-radius: 12px;
  border: 1px dashed var(--portal-border, #e8e3da);
}
.cp__dl-icon {
  font-size: 3rem;
  color: #b85c38;
}
.cp__dl-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0;
}
.cp__dl-desc {
  font-size: 0.85rem;
  color: var(--portal-muted, #6b6258);
  margin: 0;
  line-height: 1.55;
  max-width: 360px;
}
.cp__dl-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #1e2a1e;
  color: #fff;
  text-decoration: none;
  font-size: 0.88rem;
  font-weight: 700;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  transition: opacity 0.15s;
}
.cp__dl-btn:hover {
  opacity: 0.88;
}

/* Quiz */
.cp__quiz {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}
.cp__quiz-q {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.cp__quiz-q-num {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #b85c38;
  margin: 0 0 0.15rem;
}
.cp__quiz-q-label {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0;
  line-height: 1.45;
}
.cp__quiz-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.cp__quiz-opt {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border: 1.5px solid var(--portal-border, #e8e3da);
  border-radius: 9px;
  cursor: pointer;
  transition: all 0.13s;
  text-align: left;
  background: #fff;
}
.cp__quiz-opt input[type="radio"] {
  display: none;
}
.cp__quiz-opt:hover {
  border-color: #b85c38;
  background: rgba(184, 92, 56, 0.03);
}
.cp__quiz-opt--selected {
  border-color: #b85c38;
  background: rgba(184, 92, 56, 0.06);
}
.cp__quiz-opt--correct {
  border-color: #16a34a !important;
  background: rgba(22, 163, 74, 0.07) !important;
}
.cp__quiz-opt--wrong {
  border-color: #dc2626 !important;
  background: rgba(220, 38, 38, 0.05) !important;
}
.cp__quiz-opt-letter {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background: rgba(107, 98, 88, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 800;
  color: #6b6258;
  flex-shrink: 0;
}
.cp__quiz-opt--selected .cp__quiz-opt-letter {
  background: rgba(184, 92, 56, 0.15);
  color: #b85c38;
}
.cp__quiz-opt--correct .cp__quiz-opt-letter {
  background: rgba(22, 163, 74, 0.15);
  color: #16a34a;
}
.cp__quiz-opt-text {
  flex: 1 1;
  font-size: 0.88rem;
  color: #1b1b1b;
}
.cp__quiz-correct-icon {
  color: #16a34a;
  flex-shrink: 0;
}
.cp__quiz-text-answer {
  width: 100%;
  box-sizing: border-box;
  padding: 0.75rem 0.9rem;
  border: 1.5px solid var(--portal-border, #e8e3da);
  border-radius: 9px;
  font-size: 0.88rem;
  font-family: inherit;
  resize: none;
  outline: none;
  transition: border-color 0.15s;
}
.cp__quiz-text-answer:focus {
  border-color: #b85c38;
  box-shadow: 0 0 0 3px rgba(184, 92, 56, 0.1);
}

.cp__quiz-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.cp__quiz-submit {
  background: #1e2a1e;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1.5rem;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
}
.cp__quiz-submit:disabled {
  opacity: 0.4;
  cursor: default;
}
.cp__quiz-result {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.88rem;
  font-weight: 700;
  color: #16a34a;
}
.cp__quiz-retry {
  background: none;
  border: 1.5px solid rgba(22, 163, 74, 0.3);
  border-radius: 6px;
  color: #16a34a;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.3rem 0.75rem;
  cursor: pointer;
  transition: all 0.13s;
}
.cp__quiz-retry:hover {
  background: rgba(22, 163, 74, 0.08);
}

/* ── Responsive ── */
@media (max-width: 767px) {
  .cp__course-grid {
    grid-template-columns: 1fr;
  }
  .cp__video-wrap {
    border-radius: 8px;
  }
  .cp__course-hero {
    height: 160px;
  }
  .cp__lesson-row {
    padding: 0.75rem 1rem;
  }
  .cp__chapter-head {
    padding: 0.85rem 1rem;
  }
}

/* ── Progress, locked courses, finishing lessons ── */
.cp__course-card--locked { cursor: default; opacity: 0.72; }
.cp__course-card--locked:hover { transform: none; box-shadow: none; }
.cp__card-progress { height: 4px; background: rgba(107, 98, 88, 0.12); }
.cp__card-progress span { display: block; height: 100%; background: #3f7a4a; }

.cp__progress { margin: 0 0 1.25rem; }
.cp__progress-bar { height: 8px; border-radius: 99px; background: rgba(107, 98, 88, 0.12); overflow: hidden; }
.cp__progress-bar span { display: block; height: 100%; background: #3f7a4a; border-radius: 99px; transition: width 0.3s ease; }
.cp__progress-text { margin: 0.45rem 0 0; font-size: 0.82rem; font-weight: 600; color: var(--portal-muted, #6b6258); }

.cp__lesson-row--done .cp__lesson-num-badge { background: #e3efe2; color: #3f7a4a; font-size: 1rem; }
.cp__lesson-row--done .cp__lesson-name { color: var(--portal-muted, #6b6258); }

.cp__lesson-done-row { display: flex; align-items: center; flex-wrap: wrap; gap: 0.75rem; margin-top: 1.75rem; padding-top: 1.25rem; border-top: 1px solid var(--portal-border, #e8e3da); }
.cp__done-btn {
  display: inline-flex; align-items: center; gap: 0.45rem; min-height: 44px; padding: 0 1.2rem;
  border-radius: 999px; border: 1.5px solid #3f7a4a; background: #fff; color: #3f7a4a;
  font-weight: 700; font-size: 0.86rem; cursor: pointer;
}
.cp__done-btn.is-done { background: #3f7a4a; color: #fff; }
.cp__done-btn:disabled { opacity: 0.6; cursor: wait; }
.cp__done-btn:focus-visible { outline: 2px solid #b85c38; outline-offset: 2px; }
.cp__done-btn svg { font-size: 1.15rem; }
.cp__done-hint { font-size: 0.78rem; color: var(--portal-muted, #6b6258); }
@media (prefers-reduced-motion: reduce) { .cp__progress-bar span { transition: none; } }
`, "",{"version":3,"sources":["webpack://./src/portal/CoursesPage.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;4DAE4D;AAC5D;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf;;kBAEgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;4DAE4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,6DAA6D;AAC/D;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,+EAA+E;AACjF;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;AACf;AACA;EACE,gDAAgD;EAChD,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mDAAmD;AACrD;AACA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,sDAAsD;EACtD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;4DAE4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,sDAAsD;EACtD,eAAe;EACf,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;EACnC,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,sBAAsB,EAAE,SAAS;EACjC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iDAAiD;EACjD,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;AACA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,sDAAsD;AACtD,2BAA2B,eAAe,EAAE,aAAa,EAAE;AAC3D,iCAAiC,eAAe,EAAE,gBAAgB,EAAE;AACpE,qBAAqB,WAAW,EAAE,mCAAmC,EAAE;AACvE,0BAA0B,cAAc,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAE7E,gBAAgB,mBAAmB,EAAE;AACrC,oBAAoB,WAAW,EAAE,mBAAmB,EAAE,mCAAmC,EAAE,gBAAgB,EAAE;AAC7G,yBAAyB,cAAc,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,2BAA2B,EAAE;AAC9H,qBAAqB,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;;AAErH,8CAA8C,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AACpG,yCAAyC,mCAAmC,EAAE;;AAE9E,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,YAAY,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,mDAAmD,EAAE;AAC1L;EACE,oBAAoB,EAAE,mBAAmB,EAAE,YAAY,EAAE,gBAAgB,EAAE,iBAAiB;EAC5F,oBAAoB,EAAE,2BAA2B,EAAE,gBAAgB,EAAE,cAAc;EACnF,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;AACvD;AACA,wBAAwB,mBAAmB,EAAE,WAAW,EAAE;AAC1D,yBAAyB,YAAY,EAAE,YAAY,EAAE;AACrD,8BAA8B,0BAA0B,EAAE,mBAAmB,EAAE;AAC/E,oBAAoB,kBAAkB,EAAE;AACxC,iBAAiB,kBAAkB,EAAE,mCAAmC,EAAE;AAC1E,0CAA0C,yBAAyB,gBAAgB,EAAE,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   CoursesPage.css — Member portal learning section\n═══════════════════════════════════════════════════════════ */\n\n.cp__sub {\n  font-size: 0.88rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0 0 1.5rem;\n  line-height: 1.6;\n}\n\n/* ── Loading / error / empty ── */\n.cp__loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 3rem;\n  color: var(--portal-muted, #6b6258);\n  font-size: 0.88rem;\n}\n.cp__spinner {\n  width: 1.75rem;\n  height: 1.75rem;\n  border: 2px solid rgba(184, 92, 56, 0.2);\n  border-top-color: #b85c38;\n  border-radius: 50%;\n  animation: cp-spin 0.7s linear infinite;\n}\n@keyframes cp-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.cp__error-state {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 1.25rem;\n  color: #dc2626;\n  font-size: 0.85rem;\n  background: rgba(220, 38, 38, 0.06);\n  border-radius: 8px;\n}\n.cp__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 3.5rem 1rem;\n  text-align: center;\n}\n.cp__empty-icon {\n  font-size: 3rem;\n  color: var(--portal-muted, #6b6258);\n  margin-bottom: 0.85rem;\n}\n.cp__empty-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0 0 0.45rem;\n}\n.cp__empty-sub {\n  font-size: 0.85rem;\n  color: var(--portal-muted, #6b6258);\n  max-width: 380px;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* ══════════════════════════════════════════════════════════\n   COURSE GRID (list view)\n══════════════════════════════════════════════════════════ */\n.cp__course-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.25rem;\n}\n\n.cp__course-card {\n  text-align: left;\n  background: #fff;\n  border: 1px solid var(--portal-border, #e8e3da);\n  border-radius: 14px;\n  overflow: hidden;\n  cursor: pointer;\n  transition:\n    box-shadow 0.2s,\n    transform 0.2s;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n.cp__course-card:hover {\n  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.1);\n  transform: translateY(-3px);\n}\n\n/* Thumbnail */\n.cp__card-thumb {\n  width: 100%;\n  height: 160px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);\n  position: relative;\n  flex-shrink: 0;\n}\n.cp__card-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.3s;\n}\n.cp__course-card:hover .cp__card-thumb img {\n  transform: scale(1.04);\n}\n\n/* Placeholder icon when no thumbnail */\n.cp__card-thumb-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.5rem;\n  color: rgba(255, 255, 255, 0.25);\n}\n\n/* Body */\n.cp__card-body {\n  padding: 1.1rem 1.25rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.cp__card-access {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #6b6258;\n  background: rgba(107, 98, 88, 0.1);\n  padding: 0.18rem 0.55rem;\n  border-radius: 99px;\n  align-self: flex-start;\n}\n\n.cp__card-title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0;\n  line-height: 1.3;\n}\n.cp__card-desc {\n  font-size: 0.82rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0;\n  line-height: 1.55;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.cp__card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--portal-border, #e8e3da);\n}\n.cp__card-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.74rem;\n  color: var(--portal-muted, #6b6258);\n}\n.cp__card-cta {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #b85c38;\n  letter-spacing: 0.04em;\n}\n\n/* ══════════════════════════════════════════════════════════\n   COURSE VIEWER (inside a course)\n══════════════════════════════════════════════════════════ */\n.cp__course-viewer {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.cp__viewer-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 1.25rem;\n  margin-bottom: 0;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.cp__back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--portal-muted, #6b6258);\n  padding: 0;\n  transition: color 0.15s;\n}\n.cp__back-btn:hover {\n  color: #b85c38;\n}\n\n/* Course hero banner */\n.cp__course-hero {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 1.25rem;\n  background: linear-gradient(135deg, #1e2a1e 0%, #384638 100%);\n}\n.cp__course-hero img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.cp__course-hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(27, 27, 27, 0.65) 0%, transparent 60%);\n}\n.cp__course-hero-text {\n  position: absolute;\n  bottom: 1.25rem;\n  left: 1.5rem;\n  right: 1.5rem;\n}\n.cp__course-hero-title {\n  font-family: var(--portal-serif, Georgia, serif);\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 0.3rem;\n}\n.cp__course-hero-meta {\n  display: flex;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n/* Course header (no thumbnail) */\n.cp__course-header-plain {\n  background: #fff;\n  border: 1px solid var(--portal-border, #e8e3da);\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.cp__course-title {\n  font-family: var(--portal-serif, Georgia, serif);\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0;\n}\n.cp__course-desc {\n  font-size: 0.88rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0;\n  line-height: 1.6;\n}\n.cp__course-meta {\n  display: flex;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  color: var(--portal-muted, #6b6258);\n}\n\n/* ── Chapter accordion ── */\n.cp__chapters {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n.cp__chapter {\n  background: #fff;\n  border: 1px solid var(--portal-border, #e8e3da);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.cp__chapter-head {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1rem 1.25rem;\n  width: 100%;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.12s;\n}\n.cp__chapter-head:hover {\n  background: rgba(184, 92, 56, 0.03);\n}\n\n.cp__chapter-num-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background: rgba(30, 42, 30, 0.07);\n  font-size: 0.72rem;\n  font-weight: 800;\n  color: #1e2a1e;\n  flex-shrink: 0;\n}\n\n.cp__chapter-title-group {\n  flex: 1;\n  min-width: 0;\n}\n.cp__chapter-title {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0;\n}\n.cp__chapter-subtitle {\n  font-size: 0.74rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0.1rem 0 0;\n}\n\n.cp__chapter-toggle {\n  font-size: 1rem;\n  color: var(--portal-muted, #6b6258);\n  flex-shrink: 0;\n}\n\n.cp__lessons {\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid var(--portal-border, #e8e3da);\n}\n.cp__lessons-empty {\n  font-size: 0.8rem;\n  color: var(--portal-muted, #6b6258);\n  padding: 0.85rem 1.25rem;\n  font-style: italic;\n}\n\n/* Lesson row */\n.cp__lesson-row {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.85rem 1.25rem;\n  border-bottom: 1px solid var(--portal-border, #e8e3da);\n  background: none;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.12s;\n  width: 100%;\n}\n.cp__lesson-row:last-child {\n  border-bottom: none;\n}\n.cp__lesson-row:hover {\n  background: rgba(184, 92, 56, 0.04);\n}\n\n.cp__lesson-num-badge {\n  width: 1.65rem;\n  height: 1.65rem;\n  border-radius: 50%;\n  background: rgba(107, 98, 88, 0.08);\n  font-size: 0.65rem;\n  font-weight: 800;\n  color: var(--portal-muted, #6b6258);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.cp__lesson-type-dot {\n  width: 0.55rem;\n  height: 0.55rem;\n  border-radius: 50%;\n  background: #b85c38;\n  flex-shrink: 0;\n}\n.cp__lesson-type-dot--text {\n  background: #2563eb;\n}\n.cp__lesson-type-dot--task {\n  background: #16a34a;\n}\n.cp__lesson-type-dot--quiz {\n  background: #7c3aed;\n}\n.cp__lesson-type-dot--download {\n  background: #d97706;\n}\n\n.cp__lesson-info {\n  flex: 1;\n  min-width: 0;\n}\n.cp__lesson-name {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #1b1b1b;\n  margin: 0;\n}\n.cp__lesson-tags {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 0.15rem;\n}\n.cp__lesson-tag {\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--portal-muted, #6b6258);\n}\n.cp__lesson-dur-tag {\n  font-size: 0.65rem;\n  color: var(--portal-muted, #6b6258);\n  background: rgba(107, 98, 88, 0.07);\n  padding: 0.1rem 0.45rem;\n  border-radius: 99px;\n}\n.cp__lesson-arrow {\n  font-size: 0.85rem;\n  color: var(--portal-muted, #6b6258);\n  flex-shrink: 0;\n}\n\n/* ══════════════════════════════════════════════════════════\n   LESSON VIEWER\n══════════════════════════════════════════════════════════ */\n.cp__lesson-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.cp__lesson-panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--portal-border, #e8e3da);\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.cp__lesson-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--portal-muted, #6b6258);\n  padding: 0;\n  transition: color 0.15s;\n}\n.cp__lesson-back:hover {\n  color: #b85c38;\n}\n\n.cp__lesson-type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  background: rgba(184, 92, 56, 0.08);\n  color: #b85c38;\n  padding: 0.25rem 0.7rem;\n  border-radius: 99px;\n}\n.cp__lesson-dur {\n  font-weight: 500;\n  opacity: 0.7;\n}\n\n.cp__lesson-title {\n  font-family: var(--portal-serif, Georgia, serif);\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0;\n}\n\n/* Video — priority element, full-width with proper ratio */\n.cp__video-wrap {\n  position: relative;\n  padding-bottom: 56.25%; /* 16:9 */\n  height: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #000;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n.cp__video-wrap iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n.cp__video-native {\n  width: 100%;\n  border-radius: 12px;\n}\n\n/* Text / task content */\n.cp__text-content {\n  font-size: 0.9rem;\n  color: #1b1b1b;\n  line-height: 1.8;\n}\n.cp__text-content p {\n  margin: 0 0 0.85rem;\n}\n.cp__no-content {\n  font-size: 0.85rem;\n  color: var(--portal-muted, #6b6258);\n  font-style: italic;\n}\n\n/* Transcript */\n.cp__lesson-transcript {\n  background: var(--portal-surface, #faf7f2);\n  border-radius: 10px;\n  padding: 1.1rem 1.25rem;\n  border-left: 3px solid rgba(184, 92, 56, 0.3);\n}\n.cp__transcript-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--portal-muted, #6b6258);\n  margin: 0 0 0.6rem;\n}\n.cp__transcript-text {\n  font-size: 0.85rem;\n  color: #1b1b1b;\n  line-height: 1.75;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* Download block */\n.cp__download-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.85rem;\n  padding: 2.5rem 2rem;\n  background: var(--portal-surface, #faf7f2);\n  border-radius: 12px;\n  border: 1px dashed var(--portal-border, #e8e3da);\n}\n.cp__dl-icon {\n  font-size: 3rem;\n  color: #b85c38;\n}\n.cp__dl-title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0;\n}\n.cp__dl-desc {\n  font-size: 0.85rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0;\n  line-height: 1.55;\n  max-width: 360px;\n}\n.cp__dl-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: #1e2a1e;\n  color: #fff;\n  text-decoration: none;\n  font-size: 0.88rem;\n  font-weight: 700;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  transition: opacity 0.15s;\n}\n.cp__dl-btn:hover {\n  opacity: 0.88;\n}\n\n/* Quiz */\n.cp__quiz {\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n}\n.cp__quiz-q {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n.cp__quiz-q-num {\n  font-size: 0.65rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #b85c38;\n  margin: 0 0 0.15rem;\n}\n.cp__quiz-q-label {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0;\n  line-height: 1.45;\n}\n.cp__quiz-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.cp__quiz-opt {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border: 1.5px solid var(--portal-border, #e8e3da);\n  border-radius: 9px;\n  cursor: pointer;\n  transition: all 0.13s;\n  text-align: left;\n  background: #fff;\n}\n.cp__quiz-opt input[type=\"radio\"] {\n  display: none;\n}\n.cp__quiz-opt:hover {\n  border-color: #b85c38;\n  background: rgba(184, 92, 56, 0.03);\n}\n.cp__quiz-opt--selected {\n  border-color: #b85c38;\n  background: rgba(184, 92, 56, 0.06);\n}\n.cp__quiz-opt--correct {\n  border-color: #16a34a !important;\n  background: rgba(22, 163, 74, 0.07) !important;\n}\n.cp__quiz-opt--wrong {\n  border-color: #dc2626 !important;\n  background: rgba(220, 38, 38, 0.05) !important;\n}\n.cp__quiz-opt-letter {\n  width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 50%;\n  background: rgba(107, 98, 88, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n  font-weight: 800;\n  color: #6b6258;\n  flex-shrink: 0;\n}\n.cp__quiz-opt--selected .cp__quiz-opt-letter {\n  background: rgba(184, 92, 56, 0.15);\n  color: #b85c38;\n}\n.cp__quiz-opt--correct .cp__quiz-opt-letter {\n  background: rgba(22, 163, 74, 0.15);\n  color: #16a34a;\n}\n.cp__quiz-opt-text {\n  flex: 1;\n  font-size: 0.88rem;\n  color: #1b1b1b;\n}\n.cp__quiz-correct-icon {\n  color: #16a34a;\n  flex-shrink: 0;\n}\n.cp__quiz-text-answer {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.75rem 0.9rem;\n  border: 1.5px solid var(--portal-border, #e8e3da);\n  border-radius: 9px;\n  font-size: 0.88rem;\n  font-family: inherit;\n  resize: none;\n  outline: none;\n  transition: border-color 0.15s;\n}\n.cp__quiz-text-answer:focus {\n  border-color: #b85c38;\n  box-shadow: 0 0 0 3px rgba(184, 92, 56, 0.1);\n}\n\n.cp__quiz-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.cp__quiz-submit {\n  background: #1e2a1e;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 0.7rem 1.5rem;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.cp__quiz-submit:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.cp__quiz-result {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #16a34a;\n}\n.cp__quiz-retry {\n  background: none;\n  border: 1.5px solid rgba(22, 163, 74, 0.3);\n  border-radius: 6px;\n  color: #16a34a;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.3rem 0.75rem;\n  cursor: pointer;\n  transition: all 0.13s;\n}\n.cp__quiz-retry:hover {\n  background: rgba(22, 163, 74, 0.08);\n}\n\n/* ── Responsive ── */\n@media (max-width: 767px) {\n  .cp__course-grid {\n    grid-template-columns: 1fr;\n  }\n  .cp__video-wrap {\n    border-radius: 8px;\n  }\n  .cp__course-hero {\n    height: 160px;\n  }\n  .cp__lesson-row {\n    padding: 0.75rem 1rem;\n  }\n  .cp__chapter-head {\n    padding: 0.85rem 1rem;\n  }\n}\n\n/* ── Progress, locked courses, finishing lessons ── */\n.cp__course-card--locked { cursor: default; opacity: 0.72; }\n.cp__course-card--locked:hover { transform: none; box-shadow: none; }\n.cp__card-progress { height: 4px; background: rgba(107, 98, 88, 0.12); }\n.cp__card-progress span { display: block; height: 100%; background: #3f7a4a; }\n\n.cp__progress { margin: 0 0 1.25rem; }\n.cp__progress-bar { height: 8px; border-radius: 99px; background: rgba(107, 98, 88, 0.12); overflow: hidden; }\n.cp__progress-bar span { display: block; height: 100%; background: #3f7a4a; border-radius: 99px; transition: width 0.3s ease; }\n.cp__progress-text { margin: 0.45rem 0 0; font-size: 0.82rem; font-weight: 600; color: var(--portal-muted, #6b6258); }\n\n.cp__lesson-row--done .cp__lesson-num-badge { background: #e3efe2; color: #3f7a4a; font-size: 1rem; }\n.cp__lesson-row--done .cp__lesson-name { color: var(--portal-muted, #6b6258); }\n\n.cp__lesson-done-row { display: flex; align-items: center; flex-wrap: wrap; gap: 0.75rem; margin-top: 1.75rem; padding-top: 1.25rem; border-top: 1px solid var(--portal-border, #e8e3da); }\n.cp__done-btn {\n  display: inline-flex; align-items: center; gap: 0.45rem; min-height: 44px; padding: 0 1.2rem;\n  border-radius: 999px; border: 1.5px solid #3f7a4a; background: #fff; color: #3f7a4a;\n  font-weight: 700; font-size: 0.86rem; cursor: pointer;\n}\n.cp__done-btn.is-done { background: #3f7a4a; color: #fff; }\n.cp__done-btn:disabled { opacity: 0.6; cursor: wait; }\n.cp__done-btn:focus-visible { outline: 2px solid #b85c38; outline-offset: 2px; }\n.cp__done-btn svg { font-size: 1.15rem; }\n.cp__done-hint { font-size: 0.78rem; color: var(--portal-muted, #6b6258); }\n@media (prefers-reduced-motion: reduce) { .cp__progress-bar span { transition: none; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
